import React, { Component, useRef } from "react";

import {
  CCard,
  CButton,
  CCardBody,
  CCardHeader,
  CRow,
  CCol,
  CDropdown,
  CDropdownMenu,
  CDropdownItem,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CModalTitle
} from "@coreui/react";
import { saveAs } from "file-saver";
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";
import user from "../../reducers/user";
import EditFileModal from "../CommunityModal/editFile";
import FolderModal from "../CommunityModal/folder";
import InfoModal from "../CommunityModal/info";
import PermissionFileModal from "../CommunityModal/permissionFile";
import UploadModal from "../CommunityModal/upload";
import Interface from "../Interface";
import Loading from "../Loading";

class CommunityContentDocs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      docs: [],
      doc_id: null,
      selected: null,
      iframe: false,
      title: null,
      url: null,
      infoModal: false,
      folderModal: false,
      uploadModal: false,
      editModal: false,
      deleteModal: false,
      permissionModal: false
    };
    this.menuRef = React.createRef();
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  openUrl(title, url) {
    this.setState({
      iframe: true,
      url,
      title
    });
  }

  componentDidMount() {
    this.updateDocs();
  }

  download(url) {
    let a = parseInt(url.length);
    let b = parseInt(url.lastIndexOf("/"));
    let c = a - b;
    let name = url.substring(url.length - c + 1);
    let x = parseInt(name.length);
    let y = parseInt(name.indexOf("-"));
    let w = x - y;
    let nameDef = name.substring(name.length - w + 1);

    saveAs(url, nameDef);
  }

  closeModalFolder(res = null) {
    this.setState({ folderModal: false });
    this.updateDocs();
  }

  closeModalUpload(res = null) {
    this.setState({ uploadModal: false });
    this.updateDocs();
  }

  updateDocs() {
    const { id } = this.props.match.params;
    try {
      axios
        .post(
          `${URL.api}content/doc/listRoom`,
          { room_id: id, user_id: this.props.user.user.id },
          { headers: { Authorization: `Bearer ${this.props.user.token}` } }
        )
        .then(resp => {
          this.setState({ docs: resp.data.data, loading: false });
        });
    } catch (error) {
      toastr.error("Erro", "Não foi possível listar os arquivos");
    } finally {
      this.setState({ loading: false });
    }
  }

  deleteFile(fileSelected) {
    if (
      fileSelected.folder === true &&
      this.state.docs.filter(item => item.doc_id === fileSelected.id).length > 0
    ) {
      this.error("Não é possível apagar uma pasta com arquivos");
      this.setState({ deleteModal: false });
    } else {
      axios
        .post(`${URL.api}content/doc/delete/${fileSelected.id}`, null, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            this.setState({ deleteModal: false });
            this.updateDocs();
          },
          error => {
            this.error("Não foi possível listar apagar o arquivo!");
          }
        );
    }
  }

  closeModalEdit() {
    this.setState({ editModal: false });
    this.updateDocs();
  }

  render() {
    const fileSelected = this.state.docs.find(
      item => item.id === this.state.selected
    );

    return (
      <div onContextMenu={e => e.preventDefault()}>
        {this.state.iframe && (
          <Interface
            show={this.state.iframe}
            url={this.state.url}
            title={this.state.title}
            botoes={0}
            onClose={() => this.setState({ iframe: false })}
          />
        )}
        <FolderModal
          show={this.state.folderModal}
          doc_id={this.state.doc_id}
          room={this.props.match.params.id}
          onClose={e => this.closeModalFolder(e)}
        />
        <InfoModal
          show={this.state.infoModal}
          file={this.state.docs.find(item => item.id === this.state.selected)}
          onClose={() => this.setState({ infoModal: false })}
        />
        {this.state.uploadModal && (
          <UploadModal
            doc_id={this.state.doc_id}
            room={this.props.match.params.id}
            onClose={e => this.closeModalUpload(e)}
          />
        )}
        {this.state.editModal && (
          <EditFileModal
            doc_id={this.state.doc_id}
            room={this.props.match.params.id}
            onClose={() => this.closeModalEdit()}
            selected={this.state.docs.find(
              item => item.id === this.state.selected
            )}
          />
        )}
        {this.state.permissionModal && (
          <PermissionFileModal
            doc_id={this.state.doc_id}
            onClose={() => this.setState({ permissionModal: false })}
            selected={this.state.docs.find(
              item => item.id === this.state.selected
            )}
          />
        )}
        <CModal
          show={this.state.deleteModal}
          onClose={() => this.setState({ deleteModal: false })}
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton className="bg-danger">
            <CModalTitle>
              Apagar {fileSelected && fileSelected.folder ? "pasta" : "arquivo"}
            </CModalTitle>
          </CModalHeader>
          <CModalBody>
            Deseja apagar{" "}
            {fileSelected && fileSelected.folder
              ? "a pasta selecionada?"
              : "o arquivo selecionado?"}
          </CModalBody>
          <CModalFooter>
            <CButton
              color="danger"
              onClick={() => this.deleteFile(fileSelected)}
            >
              Apagar
            </CButton>{" "}
            <CButton
              color="secondary"
              onClick={() => this.setState({ deleteModal: false })}
            >
              Cancelar
            </CButton>
          </CModalFooter>
        </CModal>
        {this.props.hasPrivilege && (
          <div className="d-flex justify-content-end mb-3">
            <CButton
              color="secondary"
              className="mr-2"
              onClick={() => this.setState({ folderModal: true })}
            >
              <i className="fa fa-plus mr-2"></i>Nova pasta
            </CButton>
            <CButton
              color="primary"
              onClick={() => this.setState({ uploadModal: true })}
            >
              <i className="fa fa-cloud-upload mr-2"></i>Upload
            </CButton>
          </div>
        )}
        {this.state.loading ? (
          <Loading />
        ) : this.state.docs &&
          this.state.docs.filter(doc =>
            doc.name.toLowerCase().includes(this.props.search.toLowerCase())
          ).length > 0 ? (
          <>
            <CRow>
              {this.state.doc_id !== null && (
                <CCol md={3} sm={4}>
                  <CCard
                    className={this.state.selected === -1 && "doc-selected"}
                    onClick={() => this.setState({ selected: -1 })}
                    onDoubleClick={() =>
                      this.setState({
                        // eslint-disable-next-line react/no-access-state-in-setstate
                        doc_id: this.state.docs.find(
                          // eslint-disable-next-line react/no-access-state-in-setstate
                          item => item.id === this.state.doc_id
                        ).doc_id
                      })
                    }
                  >
                    <CCardBody
                      style={{ pointerEvents: "none", userSelect: "none" }}
                    >
                      <div className="d-flex align-items-center">
                        <i className="fa fa-folder-open text-muted"></i>
                        <span
                          className="text-ellipsis mx-3"
                          style={{ flex: 1 }}
                        >
                          ..
                        </span>
                      </div>
                    </CCardBody>
                  </CCard>
                </CCol>
              )}
              {this.state.docs &&
                this.state.docs
                  .filter(
                    doc =>
                      doc.folder === true &&
                      doc.doc_id === this.state.doc_id &&
                      doc.name
                        .toLowerCase()
                        .includes(this.props.search.toLowerCase())
                  )
                  .map(doc => (
                    <CCol md={3} sm={4}>
                      <ContextMenuTrigger id="context-menu">
                        <CCard
                          onContextMenu={() =>
                            this.setState({ selected: doc.id })
                          }
                          className={
                            this.state.selected === doc.id && "doc-selected"
                          }
                          onClick={() => this.setState({ selected: doc.id })}
                          onDoubleClick={() =>
                            this.setState({ doc_id: doc.id })
                          }
                        >
                          <CCardBody>
                            <div className="d-flex align-items-center">
                              <i className="fa fa-folder text-muted"></i>
                              <span
                                className="text-ellipsis mx-3"
                                style={{ flex: 1 }}
                              >
                                {doc.name}
                              </span>
                              <span className="text-muted">
                                {
                                  this.state.docs.filter(
                                    item => item.doc_id === doc.id
                                  ).length
                                }
                              </span>
                              <ContextMenuTrigger
                                id="context-menu"
                                mouseButton={0}
                              >
                                <CButton
                                  color="white"
                                  className="p-2 btn-pill"
                                  onClick={() =>
                                    this.setState({ selected: doc.id })
                                  }
                                >
                                  <i
                                    className="fa fa-ellipsis-v"
                                    style={{ fontSize: "1rem" }}
                                  ></i>
                                </CButton>
                              </ContextMenuTrigger>
                            </div>
                          </CCardBody>
                        </CCard>
                      </ContextMenuTrigger>
                    </CCol>
                  ))}
            </CRow>
            <CRow>
              {this.state.docs &&
                this.state.docs
                  .filter(
                    doc =>
                      doc.folder === false &&
                      doc.doc_id === this.state.doc_id &&
                      doc.name
                        .toLowerCase()
                        .includes(this.props.search.toLowerCase())
                  )
                  .map(doc => (
                    <CCol md={2} sm={3}>
                      <ContextMenuTrigger id="context-menu">
                        <CCard
                          onContextMenu={() =>
                            this.setState({ selected: doc.id })
                          }
                          className={
                            this.state.selected === doc.id && "doc-selected"
                          }
                          onClick={() => this.setState({ selected: doc.id })}
                        >
                          <CCardHeader
                            className="p-0 d-flex justify-content-center align-items-center"
                            style={{
                              pointerEvents: "none",
                              userSelect: "none"
                            }}
                          >
                            <i
                              className="fa fa-file text-danger m-0"
                              style={{ fontSize: "1.25rem" }}
                            ></i>
                            <div style={{ paddingBottom: "56.25%" }}></div>
                          </CCardHeader>
                          <CCardBody className="d-inline-flex align-items-center">
                            <div className="text-ellipsis text-center">
                              {doc.name}
                            </div>
                            <ContextMenuTrigger
                              id="context-menu"
                              mouseButton={0}
                            >
                              <CButton
                                color="white"
                                className="p-2 btn-pill"
                                onClick={() =>
                                  this.setState({ selected: doc.id })
                                }
                              >
                                <i
                                  className="fa fa-ellipsis-v"
                                  style={{ fontSize: "1rem" }}
                                ></i>
                              </CButton>
                            </ContextMenuTrigger>
                          </CCardBody>
                        </CCard>
                      </ContextMenuTrigger>
                    </CCol>
                  ))}
            </CRow>
            <ContextMenu id="context-menu" style={{ zIndex: 1000 }}>
              <CDropdown>
                <CDropdownMenu className="show">
                  <MenuItem>
                    <CDropdownItem
                      onClick={() =>
                        fileSelected && this.setState({ infoModal: true })
                      }
                    >
                      <i className="fa fa-info mr-2"></i>Informações
                    </CDropdownItem>
                  </MenuItem>
                  {fileSelected && !fileSelected.folder && (
                    <MenuItem>
                      <CDropdownItem
                        onClick={() => this.download(fileSelected.link)}
                      >
                        <i className="fa fa-cloud-download mr-2"></i>Fazer
                        download
                      </CDropdownItem>
                    </MenuItem>
                  )}
                  {fileSelected &&
                    fileSelected.user_id === this.props.user.user.id && (
                      <>
                        <MenuItem>
                          <CDropdownItem
                            onClick={() => this.setState({ editModal: true })}
                          >
                            <i className="fa fa-pencil mr-2"></i>Renomear
                          </CDropdownItem>
                        </MenuItem>
                        <MenuItem>
                          <CDropdownItem
                            onClick={() =>
                              this.setState({ permissionModal: true })
                            }
                          >
                            <i className="fa fa-share-alt mr-2"></i>Alterar
                            permissões
                          </CDropdownItem>
                        </MenuItem>
                        <MenuItem>
                          <CDropdownItem
                            onClick={() => this.setState({ deleteModal: true })}
                          >
                            <i className="fa fa-trash mr-2"></i>Apagar
                          </CDropdownItem>
                        </MenuItem>
                      </>
                    )}
                </CDropdownMenu>
              </CDropdown>
            </ContextMenu>
          </>
        ) : (
          <div className="d-flex align-items-center justify-content-center m-3">
            Nenhum documento encontrado
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommunityContentDocs);
